<template>
    <v-row no-gutters>
        <!--検索フォーム分をmin-heightに指定し常に同じ高さになるよう調整-->
        <v-col style="min-height: 58px" cols="12">
            <slot name="button-area" />
        </v-col>
        <v-col class="px-2" cols="12">
            <slot name="top-pagination-area" />
        </v-col>
        <v-col class="px-2" cols="12">
            <slot />
        </v-col>
        <v-col class="pa-2" cols="12">
            <v-row no-gutters>
                <v-col cols="12">
                    <slot name="end-pagination-area" />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'IndexPageLayout',
})
export default class IndexPageLayout extends Vue {}
</script>
